import { FleetManagment } from "./FleetManagement.component";

const FleetManagementPage: React.FC = () => {
  return <FleetManagment />;
};

export default FleetManagementPage;
